import React, { useState, useEffect } from 'react';
import EditDependentContactInfo from './EditDependentContactInfo';
import './styles/dependent-info.scss';

const EditDependentInfo = ({
  nextStep,
  prevStep,
  setShowEditDependentsContactDetails,
  editDependentsContactItem,
  enrollmentFormData,
  setEnrollmentFormData,
  dependentInformation,
  activeDependentId,
}) => {
  console.log('editDependentsContactItem', editDependentsContactItem);
  const { dependentsInformation, residenceAddress, mailingAddress } =
    editDependentsContactItem;
  console.log(
    'EditDependentInfo',
    dependentsInformation,
    residenceAddress,
    mailingAddress,
  );

  const suffix = dependentsInformation.Suffix
    ? dependentsInformation.Suffix
    : '';
  const fName =
    dependentsInformation.FirstName.charAt(0).toUpperCase() +
    dependentsInformation.FirstName.slice(1).toLowerCase();
  const lName =
    dependentsInformation.LastName.charAt(0).toUpperCase() +
    dependentsInformation.LastName.slice(1).toLowerCase();
  const fullName = suffix + fName + ', ' + lName;

  return (
    <div className="my-profile-member-container">
      <div className="dependent-info-header">
        <div>
          Update Address for <span className="full-name">{fullName}</span>
        </div>
      </div>
      <div className="dependent-selection-content">
        <div className="bg-white all-profile-component-wrapper">
          <EditDependentContactInfo
            enrollmentFormData={enrollmentFormData}
            setEnrollmentFormData={setEnrollmentFormData}
            data={editDependentsContactItem}
            nextStep={nextStep}
            prevStep={prevStep}
            setShowEditDependentsContactDetails={
              setShowEditDependentsContactDetails
            }
            dependentInformation={true}
            activeDependentId={activeDependentId}
          />
        </div>
      </div>
    </div>
  );
};

export default EditDependentInfo;
